import { defineMessages } from 'react-intl';

export default defineMessages({
    resetPasswordHeader: {
        id: 'auth.components.VerifyPassword.Reset Password',
        defaultMessage: 'Reset Password'
    },
    enterCurrentPassword: {
        id: 'auth.components.VerifyPassword.Enter your current password',
        defaultMessage: 'Enter your current password'
    },
    verify: {
        id: 'auth.components.VerifyPassword.Verify',
        defaultMessage: 'Verify'
    },
    passwordError: {
        id: 'auth.components.VerifyPassword.Password verification failed! Please enter correct password.',
        defaultMessage: 'Password verification failed! Please enter correct password.'
    },
    passwordChanged: {
        id: 'auth.components.VerifyPassword.Password changed!',
        defaultMessage: 'Password changed!'
    },
    needHelpText: {
        id: 'auth.components.VerifyPassword.Need help? Contact us by phone',
        defaultMessage: 'Need help? Contact us by phone'
    },
});
